import React, { useCallback } from 'react';

import {
  CreditCardOutlined,
  FileProtectOutlined,
  LogoutOutlined,
  QuestionCircleOutlined,
  SettingOutlined,
  ShareAltOutlined,
  UserOutlined,
} from '@ant-design/icons';
import { Dropdown } from 'antd';
import { GrUserAdmin } from 'react-icons/gr';
import { useNavigate } from 'react-router-dom';

import { StyledUserMenu } from './styles';
import { UserSettingsIcon } from '../../../components/atoms/user-settings-icon';
import { useAuth } from '../../../hooks/use-auth';
import { useAccessStatus } from '../../../hooks/use-subscription-status';
import { useGetProfileQuery } from '../../../store/queries/users';
import { Label13, variables } from '../../../theme';
import { USER_ROLES } from '../../../utils/constants';

const UserMenu = ({ backgroundColor = variables.colors.concrete, triggerSubMenuAction = 'hover' }) => {
  const navigate = useNavigate();
  const { isOnboardingComplete } = useAccessStatus();

  const { data: profileData } = useGetProfileQuery();

  const { userSignOut } = useAuth();

  const handleMenuClick = useCallback(
    (e) => {
      switch (e.key) {
        case 'admin':
          navigate('/admin');

          break;

        case 'profile':
          navigate('/user/profile');

          break;

        case 'settings':
          navigate('/user/settings');

          break;

        case 'subscription':
          navigate('/user/subscription');

          break;

        case 'payment':
          navigate('/user/payment-methods');

          break;

        case 'referrals':
          navigate('/user/referrals');

          break;

        case 'help':
          navigate('/user/help');

          break;

        case 'logout':
          userSignOut();

          break;

        default:
          break;
      }
    },
    [navigate, userSignOut],
  );

  const menuItems = [
    profileData?.role === USER_ROLES.admin && {
      label: <Label13>Admin panel</Label13>,
      key: 'admin',
      icon: <GrUserAdmin />,
    },
    isOnboardingComplete && {
      label: <Label13>Profile</Label13>,
      key: 'profile',
      icon: <UserOutlined />,
    },
    isOnboardingComplete && {
      label: <Label13>Settings</Label13>,
      key: 'settings',
      icon: <SettingOutlined />,
    },
    isOnboardingComplete && {
      label: <Label13>Subscription</Label13>,
      key: 'subscription',
      icon: <FileProtectOutlined />,
    },
    isOnboardingComplete && {
      label: <Label13>Payment Methods</Label13>,
      key: 'payment',
      icon: <CreditCardOutlined />,
    },
    isOnboardingComplete && {
      label: <Label13>Referrals</Label13>,
      key: 'referrals',
      icon: <ShareAltOutlined />,
    },
    isOnboardingComplete && {
      label: <Label13>Help</Label13>,
      key: 'help',
      icon: <QuestionCircleOutlined />,
    },
    {
      label: <Label13>Logout</Label13>,
      key: 'logout',
      icon: <LogoutOutlined />,
    },
  ].filter(Boolean);

  return (
    <StyledUserMenu>
      <Dropdown
        menu={{ items: menuItems, onClick: handleMenuClick }}
        trigger={[triggerSubMenuAction]}
        placement="bottomRight"
        getPopupContainer={(node) => node.parentElement}
      >
        <div>
          <UserSettingsIcon background={backgroundColor} />
        </div>
      </Dropdown>
    </StyledUserMenu>
  );
};

export default UserMenu;
